import project from './project';

const faviconPath = `/images/${project}/favicon.png`;

export default faviconPath;
